import React from 'react';
import ReactDOM from 'react-dom';

interface CancelModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    cancelInfo: any;
}

export const CancelModal: React.FC<CancelModalProps> = ({
                                                            isOpen, onClose, onConfirm, cancelInfo,
                                                        }) => {
    const modalRoot = document.getElementById('modal-root');

    React.useEffect(() => {
        if (isOpen) document.body.classList.add('modal-open');
        return () => document.body.classList.remove('modal-open');
    }, [isOpen]);

    if (!isOpen || !modalRoot || !cancelInfo) return null;

    return ReactDOM.createPortal(
        <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={onClose}>
            <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
                <div className="modal-content" style={{ backgroundColor: 'white' }}>
                    <div className="modal-body">
                        <div className="guide-box">
                            <h3 className="point-tit middle">예약 취소 위약금 안내</h3>
                            <p className="guide_txt middle">
                                매칭된 공고의 예약 취소에 따라 발생하는 수수료는 아래와 같으며 예약 취소 시 결제된 급여
                                금액에서 위약금을 차감 후 환원되오니 유의하시기 바랍니다.
                            </p>
                            <ul className="guidF-list mt10">
                                {cancelInfo.feeRates?.map((rate: any, index: number) => (
                                    <li key={index}>{rate.description} {rate.rate}%</li>
                                ))}
                            </ul>
                        </div>

                        <div className="modal-info-p">
                            <strong className="block">매칭된 코디와의 예약을 취소하시겠습니까?</strong>
                            <span className="block">취소 시 취소 수수료가 발생됩니다.</span>
                        </div>

                        <div className="guide-box yellow">
                            <p className="guide_txt dark-point middle text-center">
                                <span className="block">※ 취소 위약금 기준 : {cancelInfo.cancelStandard}</span>
                                <span className="block">※ 취소 위약금 : {cancelInfo.penaltyAmount?.toLocaleString()}원</span>
                            </p>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <div className="modal_btn">
                            <button type="button" className="btn cancel" onClick={onClose}>닫기</button>
                            <button type="button" className="btn confirm" onClick={onConfirm}>예약 취소</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>,
        modalRoot
    );
};